import { getCourseDetail } from '@/api/course'

const course = {
  state: {
    courseDetail: {
      id: '',
      gmtCreate: "",
      createUser: '',
      gmtModify: "",
      modifyUser: -1,
      name: "",
      code: "",
      lessonTime: '',
      overviewUserFileId: "",
      questionUserFileId: "",
      chat_list_id: "",
      type: -1,
      useGroup: "",
      outlineCount: '',
      handoutProgress: "",
      pptProgress: "",
      videoProgress: ""
    }
  },
  mutations: {
    SET_COURSE(state, val) {
      state.courseDetail = val
    },
  },
  actions: {
    async fetchCourseDetail({ commit }, id) {
      getCourseDetail({ courseId: id }).then(res => {
        if (res.code === 200) {
          commit('SET_COURSE', res.data)
        }
      })
    }
  }
}

export default course
